import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useCustomToggleStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    paddingTop: designTokens.spacing[2],
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  rowEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[3],
  },
  track: {
    position: "relative",
    width: "44px",
    height: "24px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.neutral[300],
    cursor: "pointer",
    transition: `background-color ${designTokens.transition.fast}`,
    flexShrink: 0,
    alignSelf: "center",
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: "2px",
      outlineColor: designTokens.accent[500],
      outlineOffset: "2px",
    },
  },
  trackChecked: {
    backgroundColor: designTokens.accent[500],
  },
  trackDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  thumb: {
    position: "absolute",
    top: "2px",
    left: "2px",
    width: "20px",
    height: "20px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.neutral.white,
    transition: `transform ${designTokens.transition.fast}`,
    boxShadow: designTokens.shadow.sm,
  },
  thumbChecked: {
    transform: "translateX(20px)",
  },
  toggleLabel: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
  },
  toggleLabelRegular: {
    fontWeight: designTokens.fontWeight.normal,
  },
  hint: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
  },
});
